import React, {useCallback, useEffect, useState} from 'react';
import {getLocations} from "../service/locationApi";
import {Location} from "../types/location";
import {LocationMap} from "../components/LocationMap";
import {AppState} from "../enum/appState";
import {FilterOption} from "../types/filterOption";
import {OptionsType} from "react-select";
import {emptyFilter, Filter} from "../types/filter";
import {UpdateFilterCallback} from "../types/updateFilterCallback";
import {ErrorMessage} from "../components/Ui/ErrorMessage";
import {Mode} from "../enum/mode";

type LocationProps = {
    api: string,
    categories: OptionsType<FilterOption>,
    mode: Mode
}

export default function LocationApp({api, categories, mode} : LocationProps) {

    const [locations, setLocations] = useState<Location[]>([]);
    const [appState, setAppState] = useState<AppState>(AppState.ready);
    const [selectedLocation, setSelectedLocation] = useState<Location|null>(null);
    const [filter, setFilter] = useState<Filter>(emptyFilter);

    useEffect(() => {
        setAppState(AppState.loading);
        getLocations(api).then(response => {
            setLocations(response);
            setAppState(AppState.ready);
        }, () => {
            setAppState(AppState.error);
        });
    }, [api]);


    const updateFilter = useCallback<UpdateFilterCallback>((field, value) => {
        setFilter(prevFilter => {
            return {...prevFilter, [field]: value};
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const filteredLocations = () => {
        return locations.filter((location: Location) => {
            if(filter.name && !location.name.toLowerCase().includes(filter.name.toLowerCase())) {
                return false;
            }

            if(filter.category && location.categories.indexOf(filter.category) === -1) {
                return false;
            }

            return true;
        });
    }

    return appState === AppState.error ? <ErrorMessage/> : (
        <div className="LocationContainer">
            <div className="LocationListContainer">
                <LocationMap
                    locations={filteredLocations()}
                    appState={appState}
                    selectedLocation={selectedLocation}
                    setSelectedLocation={setSelectedLocation}
                    categories={categories}
                    updateFilter={updateFilter}
                    filter={filter}
                    mode={mode}
                />
            </div>
        </div>
    );
}